import { getCollectionProducts } from '@api/collections'
import SpecialProductCard from '@components/spa/product/card'
import SpecialProductCardV2 from '@components/spa/product/cardv2'
import { TCollection, TCollectionItem, TStore, TStoreProduct } from '@components/types'
import { Select } from 'antd'
import { motion, useInView } from "framer-motion"
import { ChevronDown, X } from 'lucide-react'
import React, { useEffect, useRef, useState } from 'react'

type Props = {
    setIsCollectionOpen?: Function
    isCollectionOpen?: boolean
    collection?: TCollection
    store?: TStore
    isOpen: boolean
    setIsOpen: Function
    setSelectedProduct: Function
    maxWidth?: string
}

const MyCollection: React.FC<Props> = ({ collection, isCollectionOpen, setIsCollectionOpen, setSelectedProduct, store, setIsOpen, isOpen, maxWidth }) => {
    const [collectionProducts, setCollectionProducts] = useState < TCollectionItem[] > ([])
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef(null);
    const [skip, setSkip] = useState(0);
    const pageSize = 10;
    const [isData, setIsData] = useState(true);
    const isInView = useInView(ref);
    const SORTING_OPTIONS = [
        { value: 'relevence', label: 'Relevence' },
        { value: 'popularity', label: 'Popularity' },
        { value: 'rating', label: 'Rating: High to Low' },
    ];
    const [orderingOn, setOrderingOn] = useState < string | null > (
        SORTING_OPTIONS[0].value
    );

    function handleSortingChange(option: string) {
        setOrderingOn(option)
    }

    useEffect(() => {
        if (isInView && isData && isLoading === false) {
            setSkip((prevSkip) => prevSkip + pageSize);
        }
    }, [isInView, isData]);


    useEffect(() => {
        if (isCollectionOpen) {
            setIsLoading(true);
            getCollectionProducts(
                collection?.id,
                orderingOn,
                skip,
                pageSize
            ).then((res) => {
                if (skip === 0) {
                    setCollectionProducts(res);
                } else {
                    if (res?.length) {
                        setCollectionProducts([...collectionProducts, ...res]);
                    } else {
                        setIsData(false);
                        console.log("collectionProducts", collectionProducts);
                    }
                }

            }).finally(() => {
                setIsLoading(false);
            });
        }
    }, [skip, isCollectionOpen, orderingOn])



    return (
        <div className={`fixed ${isCollectionOpen ? 'bottom-0' : '-bottom-100%'
        } w-full z-40 flex flex-col justify-center`}>
            <motion.div className={`grid justify-items-stretch ${maxWidth?.length > 0 ? maxWidth : ""}`}
                animate={isCollectionOpen ? "open" : "closed"}
                variants={{
                    open: { x: 0, y: '90px' },
                    closed: { y: '100%' },
                }}
                transition={{ ease: "easeOut", duration: 0.5 }}
            >
                <div 
                style={{background:store?.storemeta?.settings?.shop_page_theme?.mainbg || ""}} 
                className=" bg-neutral-200 flex flex-col gap-2 justify-start w-full h-screen z-20 py-12">
                    <div className="relative flex flex-row justify-center">
                        <div style={{color:store?.storemeta?.settings?.shop_page_theme?.lighttext || ""}}  className="absolute left-4 top-4 text-neutral-900"><X onClick={(e) => { setIsCollectionOpen(false);setSkip(0); }} /></div>
                        <div 
                        style={{color:store?.storemeta?.settings?.shop_page_theme?.lighttext || ""}} 
                        className="pt-4 pb-2 font-manrope text-base text-neutral-900 font-semibold">{collection?.title}</div>
                    </div>
                    <div className="flex justify-between px-2">
                        <Select
                            size="middle"
                            placeholder="Sort"
                            options={SORTING_OPTIONS}
                            onChange={handleSortingChange}
                            defaultValue={SORTING_OPTIONS[0]?.value}
                            popupMatchSelectWidth={false}
                            suffixIcon={
                                <ChevronDown className="w-2.5 h-2.5 text-neutral-600" />
                            }
                        />
                        <span style={{color:store?.storemeta?.settings?.shop_page_theme?.lighttext || ""}}  className="text-sm font-semibold text-neutral-900">
                            {collection?.total_items || 0} items
                        </span>
                    </div>
                    <div className="flex flex-col w-full gap-2 overflow-y-scroll small-scrollbar pb-12">
                        <div className="grid grid-cols-1 gap-4 px-2">
                           {store?.storemeta?.settings?.grid_view ?
                                <div className="collapse-content py-4 grid grid-cols-2 gap-4 gap-y-6 justify-between">
                                    {collectionProducts.map((element) => {
                                        return <SpecialProductCard key={element?.id} element={{...element?.inventory?.product, inventories: [element?.inventory]} as TStoreProduct} setSelectedProduct={setSelectedProduct} setIsOpen={setIsOpen} isOpen={isOpen} />
                                    })}
                                </div>
                                :
                                <div className="collapse-content py-2 grid grid-cols-1 gap-4 border border-y-solid border-y-neutral-500">
                                    {collectionProducts.map((element) => {
                                        return <SpecialProductCardV2 store={store} key={element?.id} element={{...element?.inventory?.product, inventories: [element?.inventory]} as TStoreProduct} setSelectedProduct={setSelectedProduct} setIsOpen={setIsOpen} isOpen={isOpen} />
                                    })}
                                </div>
                            }
                            <div ref={ref} className="w-full h-16" />
                        </div>
                        <div className="w-full h-10" />
                    </div >
                </div >
            </motion.div >
        </div >

    )
}

export default MyCollection